<template>
  <v-dialog content-class="auth-dialog-container" :fullscreen="mobileBigAndBelow" persistent v-model="vModelCondition">
    <circle-loader v-if="vModelCondition && !iFrameLoaded && showSpinnerWithDelay && !loginDialogState"></circle-loader>
    <iframe class="hiddenUntilIframeLoad" data-class="auth-server-iframe" ref="authServerIframe" id="iframe" :style="{width: calculatedWidth, height: calculatedHeight}" :scrolling="enableIframeScroll" allowfullscreen frameborder="0" :src="this.authUrl" @load="iframeLoaded" style="border:0; z-index: 401"></iframe>
    <v-tooltip
      v-model="tooltip"
      location="bottom"
      content-class="auth-tooltip">
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </v-dialog>
</template>

<script>
import store from '@/store'
import Session from '@/components/mixins/Session'
import Screen from '@/components/mixins/Screen'
import Branding from '@/components/mixins/Branding'
import lib from '@/library'
import mobileBridge from '@/library/mobileBridge'
import CircleLoader from '@/components/common/CircleLoader'
export default {
  components: {
    CircleLoader
  },
  props: {},

  data () {
    return {
      show: true,
      authUrl: null,
      calculatedHeight: '0',
      calculatedWidth: '800px',
      iframeTimer: null,
      error: false,
      iframeExpired: false,
      authSenderList: ['authServerStyle', 'closeTimeout', 'authServerEvent'],
      postMessageFunction: false,
      tooltip: false,
      tooltipText: '',
      iFrameLoaded: false,
      showSpinnerWithDelay: false
    }
  },
  mixins: [
    Session,
    Screen,
    Branding
  ],
  computed: {
    authDialogData () {
      return store.getters['overlayState/getAuthDialogState']
    },
    isLoggedIn () {
      return store.getters['isLoggedIn']
    },
    authServerIframeRef () {
      return (this.$refs && this.$refs.authServerIframe) || undefined
    },
    vModelCondition () {
      return this.show && this.authUrl
    },
    userAgent () {
      return lib.core.userAgent.os.name
    },
    monitorScreenWidthChange () {
      return this.screenWidth
    },
    enableIframeScroll () {
      // enable scrolling on small height mobile devices (<= 655px)
      return this.mobileBigAndBelow && this.screenHeight <= 655 ? 'yes' : 'no'
    },
    loginDialogState () {
      return store.getters['overlayState/getLoginDialogState']
    },
    // Payments START
    currentPaymentType () {
      return store.getters['nuvei/currentNuveiType']
    }
    // Payments END
  },

  methods: {
    closeDialog () {
      store.dispatch('overlayState/activateAuthDialog', false)
      this.show = false
      this.authUrl = null
    },
    iframeLoaded () {
      this.iFrameLoaded = true
      this.showSpinnerWithDelay = false
      setTimeout(() => {
        console.log('AUTH iframe loaded')
        this.$refs.authServerIframe.classList.remove('hiddenUntilIframeLoad')
      }, 250)
    },
    startIframeTimeTracker (newExpirationTime = false) {
      let iframeExpirationTime = newExpirationTime || this.authDialogData.expiresAtUtc
      if (this.authDialogData && iframeExpirationTime) {
        let currentDate = new Date().getTime()
        let tokenExpiration = new Date(iframeExpirationTime).getTime()
        let dateDifference = tokenExpiration - currentDate
        this.setIframeTimer(dateDifference)
      }
    },
    setIframeTimer (time) {
      this.iframeTimer = setTimeout(() => {
        this.iframeExpired = true
        this.onClose()
      }, time)
    },
    onClose (closeTimeout = false) {
      this.authUrl = null
      this.show = false
      this.showSpinnerWithDelay = false
      this.iFrameLoaded = false
      clearTimeout(this.iframeTimer)
      if (this.postMessageFunction) window.removeEventListener('message', this.postMessageFunction, false)
      if (this.authDialogData.actionName && this.authDialogData.actionName.toLowerCase() === 'login') {
        if (!closeTimeout) {
          store.dispatch('overlayState/deactivateLoginDialog')
        } else {
          store.commit('setFormSubmitSppiner', false)
        }
      }
      this.postMessageFunction = false
      store.dispatch('overlayState/activateAuthDialog', false)
      this.handlePayments()
    },
    handlePayments () {
      if (this.currentPaymentType) {
        store.commit(`nuvei/${this.currentPaymentType}/setProcessing`, false)
      }
      store.commit('pnmGateway/pnmDebit/setProcessing', false)
      store.commit('pnmGateway/pnmAch/setProcessing', false)
      store.commit('pnmGateway/pnmAPay/setProcessing', false)
      store.commit('pnmGateway/pnmCash/setProcessing', false)
      store.commit('pnmGateway/pnmCredit/setProcessing', false)
      store.commit('pnmGateway/pnmGPay/setProcessing', false)
      store.commit('pnmGateway/pnmPayPal/setProcessing', false)
      store.commit('pnmGateway/pnmPushDebit/setProcessing', false)
      store.commit('pnmGateway/pnmVenmo/setProcessing', false)
      store.commit('paysafe/setIsTransactionProcessingInvoked', false)
      store.commit('paysafe/setProcessingPaysafeTransaction', false)
      store.dispatch('paysafe/hideDialog')
      store.commit('sightline/setIsTransactionProcessingInvoked', false)
      store.commit('sightline/setIsProcessingDeposit', false)
      store.commit('sightline/setIsProcessingWithdrawal', false)
      store.commit('sightline/setProcessingDialog', false)
    },
    postMessageEventListener () {
      let self = this
      this.postMessageFunction = function (event) {
        if (event.data && !event.data.sender && !self.authSenderList.includes(event.data.sender)) return false
        console.log('AUTH iframe event listener', event.data)
        if (event.data.sender === 'authServerStyle') {
          if (!self.mobileBigAndBelow && !self.error) {
            // content within the iframe is changable, therefore fixed heights are implemented in order to prevent uneccessary scroll
            // fixed heights are optimized based on the current content per iframe screen
            // event.data.pswsActionData is not always accurate so in order to prevent screen cut-off had to implement screen modes (small, medium, large)
            let iframeHeight = event.data.pswsActionData
            // TOTP_ERR screen height
            if (event.data.pswsAction === 'TOTP_ERR_HEIGHT') {
              self.calculatedHeight = event.data.pswsActionData
              return
            }
            // CODES GENERATE screen height
            // if (event.data.pswsAction === 'CODES_GENERATE') {
            //   self.calculatedHeight = event.data.pswsActionData
            //   return
            // }
            if (iframeHeight >= 340 && iframeHeight <= 530) { // small height screen
              self.calculatedHeight = '530px'
            } else if (iframeHeight >= 550 && iframeHeight <= 610) { // medium height screen
              self.calculatedHeight = '610px'
            } else if (iframeHeight >= 611) { // large height screen
              self.calculatedHeight = '730px'
            } else { // all other screens cases (if any) come to default of 545px
              self.calculatedHeight = '545px'
            }
          } else if (!self.mobileBigAndBelow && self.error) {
            // 400, 404, 500 Error Page Height on the initial load of the iframe
            self.calculatedHeight = '500px'
          }
        }
        if (event.data.sender === 'authServer' && event.data.pswsAction && event.data.pswsAction === 'closeTimeout') {
          self.onClose(true)
        }
        if (event.data.sender === 'authServerEvent' && event.data.pswsAction === 'click') {
          self.userIsActive()
        }
        if (event.data.sender === 'authServerEvent' && event.data.pswsAction === 'copyclipboard') {
          if (this.userAgent === 'android') {
            mobileBridge.bridgeSendRequest('copyToClipboard', event.data.pswsActionData)
          } else {
            navigator.clipboard.writeText(event.data.pswsActionData).then(() => {
              self.tooltipMessage(`${self.$t('Account.AuthDialog.CodeCopied')}`)
            }).catch((err) => {
              self.tooltipMessage(`${err.message}`)
            })
          }
        }
      }
      window.addEventListener('message', this.postMessageFunction, false)
    },
    tooltipMessage (msg) {
      if (this.userAgent === 'android') return false
      this.tooltip = true
      this.tooltipText = msg
      setTimeout(() => {
        this.tooltip = false
      }, 3000)
    }
  },

  created () {},
  beforeMount () {
    if (this.mobileBigAndBelow) {
      this.calculatedHeight = '100%'
      this.calculatedWidth = '100%'
    } else {
      // default height implemented on desktop view in order to prevent iframe screen cut-off in moments of gap in server-client communication, get's overriden in postMessageEventListener()
      this.calculatedHeight = '530px'
    }
    if (this.authDialogData && this.authDialogData.redirectUrl) {
      this.authUrl = this.authDialogData.redirectUrl + '&brand=' + this.brandKey
      this.postMessageEventListener()
      if (this.authUrl.indexOf('Error') > -1) {
        this.error = true
      }
    }
  },
  beforeDestroy () {
    if (!this.iframeExpired) {
      this.onClose()
    }
    this.iframeExpired = false
  },
  watch: {
    isLoggedIn (newVal) {
      if (!newVal) {
        this.onClose()
      }
    },
    authDialogData (newVal) {
      if (newVal && newVal.redirectUrl) {
        this.authUrl = newVal.redirectUrl + '&brand=' + this.brandKey
        if (newVal.redirectUrl.indexOf('Error') > -1) {
          this.error = true
        }
      }
    },
    monitorScreenWidthChange (newVal) { // detecting screen resizing and updating iframe screen dimnesions accordingly
      if (newVal && !this.mobileBigAndBelow && (this.authDialogData.actionName && this.authDialogData.actionName === 'CODES-GENERATE')) {
        // generated codes iframe screen with most content and height
        this.calculatedHeight = '730px'
      } else if (newVal && !this.mobileBigAndBelow) {
        // desktop view default iframe screen height dimension
        this.calculatedHeight = '545px'
      } else if (newVal && this.mobileBigAndBelow) {
        // mobile view default iframe screen height dimension
        this.calculatedWidth = '100%'
        this.calculatedHeight = '100%'
      }
    },
    vModelCondition (newVal) {
      if (newVal) {
        if (newVal) {
          const spinnerDelay = this.mobileBigAndBelow ? 0 : 1000
          setTimeout(() => {
            this.showSpinnerWithDelay = true
          }, spinnerDelay)
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/css/config'

>>>.auth-dialog-container
  background transparent !important
  padding 0
  overflow-x hidden
  -ms-overflow-style none  /* IE and Edge */
  scrollbar-width none
  &::-webkit-scrollbar
    display none
  #iframe
    border-radius 10px
    @media mobile-big-and-below
      border-radius 0
  .hiddenUntilIframeLoad
    opacity 0
    pointer-events none
  .loader
    position absolute
    top 50%
    left 50%
    margin-top -40px !important
    margin-left -40px !important
    height 80px !important
    width 80px !important
    @media mobile-big-and-below
      height 30px !important
      width 30px !important
      margin-top -15px !important
      margin-left -15px !important
      border-width 4px
      border-top-width 4px
  @media mobile-big-and-below
    background-color rgba(255, 255, 255, 0.1) !important
.auth-tooltip
  background var(--auth-dialog-tooltip)
  top 0 !important
  bottom auto
  left 50% !important
  transform: translate(-50%, 0%)
  width 100%
  text-align center
  padding 6px 0 !important
  font-size 14px
  border-radius 4px
  @media mobile-big-and-below
    top auto !important
    bottom 0
    padding 2px !important
</style>



// WEBPACK FOOTER //
// src/components/common/AuthDialog.vue